import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import leftIcon from "../_assets/images/left_icon.png";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertFromRaw, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { Button } from "../_components/button.component";
import { AnnouncementService } from "../_service/announcement.service";

export const ANNOUNCEMENT_ROUTE = "/announcement";

let userListGlobal = [];

function AnnouncementPageComponent({ user, history, addToast }) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [isLoading, setIsLoading] = useState(false);

  const isFormSubmitable = title.length > 1 && description.length > 1;

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    setDescription(editorState.getCurrentContent().getPlainText());
  };

  const addAnnouncement = () => {
    setIsLoading(true);
    var convertedDescription = convertToRaw(editorState.getCurrentContent());
    AnnouncementService.addAnnouncement(user, {
      title: title,
      description: JSON.stringify(convertedDescription),
    })
      .then((resp) => {
        setIsLoading(false);
        addToast("Announcement Created successfully", "", ToastTypes.success);
        history.push("/");
      })
      .catch((error) => {
        setIsLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  return (
    <div className="page-container ml-auto px-9 py-6 org-details-container">
      <div className="flex pb-4 back-btn-container items-center cursor-pointer">
        <img src={leftIcon} alt="" onClick={() => history.push("/")} />
        <span
          className="ml-3 text-xl home-text"
          onClick={() => history.push("/")}>
          Home
        </span>
      </div>
      <div className="flex flex-wrap">
        <div className="bg-white rounded-xl w-full">
          <div className="p-6">
            <input
              placeholder="Title"
              className="w-full"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />
          </div>
          <div className="" style={{ minHeight: "60vh" }}>
            <Editor
              placeholder="Enter Text"
              wrapperClassName="wrapper-class p-6"
              editorClassName="editor-class p-4 rounded"
              toolbarClassName="toolbar-class mt-2 shadow card"
              editorState={editorState}
              onEditorStateChange={onEditorStateChange}
              toolbar={{
                options: ["inline", "blockType", "fontSize", "emoji"],
                inline: { inDropdown: true },
              }}
            />
          </div>
        </div>
        <div
          className={`mt-3 flex-row-reverse w-full ${
            !isLoading ? "flex" : ""
          }`}>
          <Button
            label="Send Message"
            disabled={!isFormSubmitable}
            isLoading={isLoading}
            onClick={() => addAnnouncement()}
          />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth,
});

const AnnouncementPage = withToast(
  connect(mapStateToProps)(AnnouncementPageComponent)
);

export default AnnouncementPage;
